const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Generate srcSet string for responsive images.
 * Uses the /api/img/optimize endpoint to serve resized versions.
 * 
 * @param {string} src - Image source path (e.g. "https://files.ihgbrands.com/ihg-ind/generated/hero.webp" or full URL)
 * @param {number[]} widths - Array of widths to generate (default: [400, 800, 1200])
 * @returns {string} srcSet string for use in <img> or <source> tags
 */
export function getSrcSet(src, widths = [400, 800, 1200]) {
  if (!src) return '';
  
  // For local uploads, use the optimize endpoint
  const isLocal = src.startsWith('https://files.ihgbrands.com/ihg-ind/') || src.startsWith('uploads/');
  const isApiPath = src.startsWith('/api/') || src.startsWith(`${API}/api/`);
  
  // Don't generate srcSet for tiny images, SVGs, or API endpoints
  if (isApiPath || src.endsWith('.svg') || src.includes('data:image')) return '';
  
  // For local paths
  if (isLocal) {
    return widths
      .map(w => `${API}/api/img/optimize?url=${encodeURIComponent(src)}&w=${w}&fmt=webp ${w}w`)
      .join(', ');
  }
  
  // For full URLs (already includes domain)
  if (src.startsWith('http')) {
    return widths
      .map(w => `${API}/api/img/optimize?url=${encodeURIComponent(src)}&w=${w}&fmt=webp ${w}w`)
      .join(', ');
  }
  
  // For relative paths served from the backend
  const fullSrc = src.startsWith('/') ? src : `/${src}`;
  return widths
    .map(w => `${API}/api/img/optimize?url=${encodeURIComponent(fullSrc)}&w=${w}&fmt=webp ${w}w`)
    .join(', ');
}

/**
 * Common sizes attribute patterns for responsive layouts.
 */
export const SIZES = {
  // Full width (hero images, single column)
  fullWidth: '100vw',
  // 2 columns on desktop, full on mobile
  twoCol: '(max-width: 768px) 100vw, 50vw',
  // 3 columns on desktop, 2 on tablet, full on mobile
  threeCol: '(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw',
  // 4 columns on desktop, 2 on tablet, full on mobile
  fourCol: '(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw',
  // Sidebar image (smaller)
  sidebar: '(max-width: 768px) 100vw, 33vw',
  // Thumbnail
  thumb: '200px',
};
